<mat-expansion-panel class="simulation-step-panel">
    <mat-expansion-panel-header class="simulation-step-panel__header">
        @if (showDragHandle) {
            <button type="button" mat-icon-button class="simulation-step-panel__handle" cdkDragHandle
                (click)="$event.stopPropagation()" aria-label="Reorder simulation step">
                <mat-icon>drag_indicator</mat-icon>
            </button>
        }

        <mat-panel-title class="text-color-primary">
            {{ title }}
        </mat-panel-title>

        <mat-panel-description class="card-node-name simulation-step-panel__value--ellipsis">
            {{ description }}
        </mat-panel-description>
    </mat-expansion-panel-header>

    @if (simulationValues) {
        <div class="simulation-step-panel__content text-color-primary">
            <p class="simulation-step-panel__label">Target node</p>
            <p class="simulation-step-panel__value">{{ step.name }}</p>
            <p class="simulation-step-panel__value">UUID: {{ stepId }}</p>
            <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                <mat-label>Step ID</mat-label>
                <input matInput readonly [id]="'' + stepOrder" [value]="stepOrder">
            </mat-form-field>

            <p>Task Duration</p>

            <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                <mat-label>Task Duration in Average</mat-label>
                <input matInput [(ngModel)]="simulationValues.task_duration_avg">
            </mat-form-field>

            <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                <mat-label>Task Duration standard deviation</mat-label>
                <input matInput type="number" [ngModel]="simulationValues.task_duration_stdev"
                    (ngModelChange)="simulationValues.task_duration_stdev = $event === '' ? null : +$event">
            </mat-form-field>

            <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                <mat-label>Task Duration Variability</mat-label>
                <mat-select [(ngModel)]="simulationValues.task_duration_variability">
                    @for (option of taskDurationVariabilityOptions; track option) {
                        <mat-option [value]="option">
                            {{ option }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <section class="simulation-step-panel__advanced-toggle">
                <button
                    type="button"
                    class="simulation-step-panel__advanced-toggle-button"
                    [class.simulation-step-panel__advanced-toggle-button--active]="showAdvancedSettings"
                    role="switch"
                    [attr.aria-checked]="showAdvancedSettings"
                    (click)="showAdvancedSettings = !showAdvancedSettings">
                    <span class="simulation-step-panel__advanced-toggle-label">Advanced Settings</span>
                    <span class="simulation-step-panel__advanced-toggle-track" aria-hidden="true">
                        <span class="simulation-step-panel__advanced-toggle-thumb"></span>
                    </span>
                </button>
            </section>

            @if (showAdvancedSettings) {
                <div class="simulation-step-panel__advanced text-color-primary">
                    <p>Resources Pool</p>

                    <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                        <mat-label>Resource ID</mat-label>
                        <mat-select
                            [ngModel]="simulationValues.resource_id"
                            (ngModelChange)="setSimulationStepResource(simulationValues, $event)">
                            <mat-option [value]="null">None</mat-option>
                            @for (resource of simulationResourcesStructure; track $index) {
                                <mat-option [value]="resource.resource_id">
                                    {{ resource.resource_name || resource.resource_id }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <p>Resource Units</p>

                    <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                        <mat-label>Resource Units</mat-label>
                        <input matInput type="number" [(ngModel)]="simulationValues.resource_units">
                    </mat-form-field>

                    <!-- <p>Group</p> -->

                    <!--
                    <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                        <mat-label>Group</mat-label>
                        <input matInput [(ngModel)]="simulationValues.group">
                    </mat-form-field>
                    -->

                    <p>Group Assignation</p>

                    <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                        <mat-label>Group Assignation</mat-label>
                        <mat-select [(ngModel)]="simulationValues.group_assignation">
                            <mat-option value="">None</mat-option>
                            <mat-option value="soft">Soft</mat-option>
                            <mat-option value="hard">Hard</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <p>Allow abandon</p>

                    <section>
                        <mat-checkbox class="text-color-primary"
                            [(ngModel)]="simulationValues.allow_abandon">Allow abandon</mat-checkbox>
                    </section>
                    @if (simulationValues.allow_abandon) {
                        <div class="mb-3">
                            <control-slider [control]="simulationValues.waitSlider"></control-slider>
                        </div>
                    }
                </div>
            }

            <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                <mat-label>Queue Priority</mat-label>
                <input matInput type="number" [(ngModel)]="simulationValues.queue_priority">
            </mat-form-field>

            <section>
                <mat-checkbox class="text-color-primary" [(ngModel)]="simulationValues.is_terminal">Is
                    Terminal</mat-checkbox>
            </section>

            <div class="mb-2">
                <div class="mb-3">
                    <mat-checkbox class="text-color-primary"
                        [ngModel]="simulationValues.no_worker"
                        (ngModelChange)="onNoWorkerChange($event)">No Worker</mat-checkbox>
                </div>
                @if (!simulationValues.no_worker) {
                    <div class="mb-3">
                        <control-slider [control]="simulationValues.workersSlider"></control-slider>
                    </div>
                }
                <div class="mb-3">
                    <control-slider [control]="simulationValues.timeSlider"></control-slider>
                </div>
            </div>

            <div class="simulation-step-links">
                <div class="simulation-step-links__group">
                    <p class="simulation-step-panel__helper">Previous steps</p>
                    <div class="simulation-step-links__controls">
                        <mat-form-field appearance="outline" class="simulation-step-links__select">
                            <mat-label>Add previous step</mat-label>
                            <mat-select [ngModel]="relation.selectedPreviousNodeId"
                                (ngModelChange)="onRelationSelectionChange('previous', $event)">
                                @for (option of getAvailableRelationOptions('previous'); track option.dbPropierties.__EDT_UUID__) {
                                    <mat-option [value]="option.dbPropierties.__EDT_UUID__">
                                        {{ getSimulationStepCodeByNodeId(option.dbPropierties.__EDT_UUID__) }} - {{ option.name ||
                                        option.dbPropierties.__EDT_UUID__ }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <button type="button" mat-stroked-button class="simulation-step-links__button"
                            [disabled]="!relation.selectedPreviousNodeId"
                            (click)="addRelationNode('previous')">
                            Add
                        </button>
                    </div>

                    <div class="simulation-step-links__items">
                        @for (relationNodeId of getRelationNodeIds('previous'); track relationNodeId) {
                            <div class="simulation-step-links__item">
                                <span>{{ getSimulationStepCodeByNodeId(relationNodeId) }} - {{ getNodeNameByID(relationNodeId)?.name || relationNodeId }}</span>
                                <button type="button" mat-icon-button
                                    (click)="removeRelationNode('previous', relationNodeId)"
                                    aria-label="Remove previous step">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        } @empty {
                            <p class="simulation-step-links__empty">No previous steps.</p>
                        }
                    </div>

                    <mat-form-field appearance="outline" class="simulation-step-links__select mt-2">
                        <mat-label>Select previus task dependency type</mat-label>
                        <mat-select [(ngModel)]="simulationValues.previusTaskValue">
                            @for (option of previusTaskDepencency; track $index) {
                                <mat-option [value]="option">
                                    {{ option.value }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <hr>
                <div class="simulation-step-links__group">
                    <p class="simulation-step-panel__helper">Next steps</p>
                    <div class="simulation-step-links__controls">
                        <mat-form-field appearance="outline" class="simulation-step-links__select">
                            <mat-label>Add next step</mat-label>
                            <mat-select [ngModel]="relation.selectedNextNodeId" (ngModelChange)="onRelationSelectionChange('next', $event)">
                                @for (option of getAvailableRelationOptions('next'); track option.dbPropierties.__EDT_UUID__) {
                                    <mat-option [value]="option.dbPropierties.__EDT_UUID__">
                                        {{ getSimulationStepCodeByNodeId(option.dbPropierties.__EDT_UUID__) }} - {{ option.name ||
                                        option.dbPropierties.__EDT_UUID__ }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <button type="button" mat-stroked-button class="simulation-step-links__button"
                            [disabled]="!relation.selectedNextNodeId"
                            (click)="addRelationNode('next')">
                            Add
                        </button>
                    </div>

                    <div class="simulation-step-links__items">
                        @for (relationNodeId of getRelationNodeIds('next'); track relationNodeId) {
                            <div class="simulation-step-links__item">
                                <span>{{ getSimulationStepCodeByNodeId(relationNodeId) }} - {{ getNodeNameByID(relationNodeId)?.name || relationNodeId }}</span>
                                <button type="button" mat-icon-button
                                    (click)="removeRelationNode('next', relationNodeId)"
                                    aria-label="Remove next step">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        } @empty {
                            <p class="simulation-step-links__empty">No next steps.</p>
                        }
                    </div>

                    <mat-form-field appearance="outline" class="simulation-step-links__select mt-2 mb-2">
                        <mat-label>Select next task dependency type</mat-label>
                        <mat-select [(ngModel)]="simulationValues.nextTaskValue" (ngModelChange)="onNextTask()">
                            @for (option of nextTaskType; track $index) {
                                <mat-option [value]="option">
                                    {{ option.value }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (simulationValues.nextTaskProb) {
                        @for (relationNodeId of getRelationNodeIds('next'); track relationNodeId) {
                            <p class="text-color-primary">
                                {{ getSimulationStepCodeByNodeId(relationNodeId) }} - {{ getNodeNameByID(relationNodeId)?.name || relationNodeId }}
                            </p>
                            <div class="d-flex justify-content-center align-items-center">
                                <mat-form-field appearance="outline" class="simulation-step-panel__id-field">
                                    <mat-label>Probability</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        [ngModel]="getTaskProbabilityValue(relationNodeId)"
                                        (ngModelChange)="setTaskProbabilityValue(relationNodeId, $event)">
                                </mat-form-field>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    }
</mat-expansion-panel>
